// extracted by mini-css-extract-plugin
module.exports = {"bookrack":"bookrack-3ra7zG-z","bookrackImg":"bookrackImg-1WAgmD8M"};